var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"card card-info card-outline"},[_c('div',{staticClass:"card-body"},[_c('AreaHolidays')],1)])]),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card card-info card-outline"},[_c('div',{staticClass:"card-body"},[_c('DaysHolidaysYears')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }